import { Pipe, PipeTransform } from '@angular/core';
import { sprintf } from 'sprintf-js';

/**
 * sprintf: return the given string (text with formatting instructions) with the given replacements filled in
 */
@Pipe({
  name: 'sprintf'
})
export class SprintfPipe implements PipeTransform {
  public transform(input: string, ...replacements: (string | number)[]): string {
    return sprintf(input, ...replacements);
  }
}
